import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MonthNames } from '../../index.constants';
import { DateRangeContext } from '../../index.context';
import { Years } from './Years';
import * as S from './index.styles';

export const Controller = ({ onChangeYear, onChangeMonth, date, hideMonthsControl }) => {
    const { dispatch, state } = useContext(DateRangeContext);

    const month = state[date].getMonth();
    const year = state[date].getFullYear();

    const renderMonthsControl = () => (
        <S.StyledMonths>
            <S.ControllButton
                icon={['far', 'chevron-left']}
                onClick={() => dispatch({ type: onChangeMonth, quantity: -1 })}
            />
            <S.StyledInfo>{MonthNames[month]}</S.StyledInfo>
            <S.ControllButton
                icon={['far', 'chevron-right']}
                onClick={() => dispatch({ type: onChangeMonth, quantity: 1 })}
            />
        </S.StyledMonths>
    );

    return (
        <S.StyledController>
            {!hideMonthsControl && renderMonthsControl()}
            <Years year={year} onChangeYear={onChangeYear} />
        </S.StyledController>
    );
};

Controller.propTypes = {
    onChangeYear: PropTypes.string,
    onChangeMonth: PropTypes.string,
    date: PropTypes.string,
    hideMonthsControl: PropTypes.bool,
};

/* istanbul ignore next */
Controller.defaultProps = {
    onChangeYear: '',
    onChangeMonth: '',
    date: 'initialDate',
    hideMonthsControl: false,
};
